<template>
  <div class="mb-5">
    <!-- <div class="pdf-icon">
      <a @click="createPdf">
        <img src="@/assets/images/pdf.png" alt="PDF" height="32" />
      </a>
    </div> -->
    <div id="cash-holding-report" class="table-responsive">
      <table class="table table-bordered mt-3" style="white-space: nowrap;">
        <thead>
          <tr>
            <th>Dato</th>
            <th>Terminal</th>
            <th>Dagsstart</th>
            <th>Total Kontantbetaling</th>
            <th>Kontantuttak</th>
            <th>Dagsslutt</th>
            <th>Avvik</th>
            <th>Kommentar</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(report, index) in zReports" :key="index" :class="{'table-warning': hasDiff(report)}">
            <td>{{ formatDate(report) }}</td>
            <td>{{ getTerminalName(report) }}</td>
            <td>{{ displayAmount(getDayStartedCashAmount(report)) }}</td>
            <td>{{ displayAmount(getCashPaymentsTotalAmount(report)) }}</td>
            <td>{{ getCashWithdrawalAmount(report) ? displayAmount(getCashWithdrawalAmount(report)) : '' }}</td>
            <td>{{ displayAmount(getDayEndedCashAmount(report)) }}</td>
            <td>{{ getDiff(report) ? displayAmount(getDiff(report)) : '' }}</td>
            <td>{{ getComment(report) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import MathUtil from "@/util/MathUtil";
  import moment from "moment";

  export default {
    props: {
      zReports: Array,
      terminals: Array
    },
    methods: {
      getReportData(report) {
        return report.cagistahospitality || report;
      },
      formatDate(report) {
        let data = this.getReportData(report);
        if (data.createdTime) {
          return moment(data.createdTime).format('DD.MM.YYYY HH:mm');
        }
        return '';
      },
      getTerminalName(report) {
        let data = this.getReportData(report);
        let terminalId = data.terminalId;
        if (!terminalId) return '';
        if (this.terminals) {
          let terminal = this.terminals.find(t => t.terminalId == terminalId || t.id == terminalId);
          if (terminal && terminal.deviceName) {
            return terminal.terminalType + ' - ' + terminal.deviceName;
          }
        }
        return terminalId;
      },
      getDayStartedCashAmount(report) {
        let data = this.getReportData(report);
        return data.dayStartedCashAmount;
      },
      getDayEndedCashAmount(report) {
        let data = this.getReportData(report);
        return data.dayEndedCashAmount;
      },
      getDiff(report) {
        let data = this.getReportData(report);
        return data.diff;
      },
      getCashPaymentsTotalAmount(report) {
        let data = this.getReportData(report);
        let cashPickup = data.cashPickupPaymentsTotalAmount || 0;
        let cashDineIn = data.cashDineInPaymentsTotalAmount || 0;
        let cashDelivery = data.cashDeliveryPaymentsTotalAmount || 0;
        return cashPickup + cashDineIn + cashDelivery;
      },
      getCashWithdrawalAmount(report) {
        let data = this.getReportData(report);
        return data.cashWithdrawalAmount;
      },
      getComment(report) {
        let data = this.getReportData(report);
        let parts = [];
        if (data.cashWithdrawalReason) parts.push('Uttak: ' + data.cashWithdrawalReason);
        if (data.comment) parts.push('Avvik: ' + data.comment);
        return parts.join(' | ');
      },
      hasDiff(report) {
        let diff = this.getDiff(report);
        return diff != null && diff != 0;
      },
      displayAmount(num) {
        if (num != null && (num > 0 || num < 0)) {
          return MathUtil.displayTwoDecimals(num);
        }
        return num == 0 ? '0,00' : '-';
      },
    }
  }
</script>
